import * as angular from "angular";
import {ItemSetting} from "../models/itemSetting.model";
import {ServiceValidationTemplateModel} from "../models/service-validation-template.model";
import {ExportType} from "../../commons/types/export.type";
import {ExportPricePlanPayloadModel} from "../angular/models/export-price-plan-payload.model";

export class PricePlanBundleRequestsService {
  constructor(private $pricePlanBundle, private PricePlanBundleAPI) {
  }

  getRootBundles() {
    const api = this.PricePlanBundleAPI.actions.getRootBundles;
    return this.$$call(api, {}, {}, {});
  }


  getPricePlanBundleByAccountId(_accountId) {
    const api = this.PricePlanBundleAPI.actions.accountPricePlans;
    return this.$$call(api, {}, {}, {accountId: _accountId});
  }


  getDefaultProgramTypeByServiceType(accountId, serviceType) {
    const api = this.PricePlanBundleAPI.actions.getDefaultProgramTypeByServiceType;
    return this.$$call(api, {}, {}, {accountId: accountId, serviceType: serviceType});
  }


  getSitePrograms() {
    const api = this.PricePlanBundleAPI.actions.getSitePrograms;
    return this.$$call(api, {}, {}, {});
  }


  getSiteServicesProgramType() {
    const api = this.PricePlanBundleAPI.actions.getSiteServicesProgramType;
    return this.$$call(api, {}, {}, {});
  }


  getSiteAdditions(ids?) {
    const api = this.PricePlanBundleAPI.actions.getSiteAdditions;
    return this.$$call(api, {ids: ids}, {}, {});
  }


  createSiteAddition(addition) {
    const api = this.PricePlanBundleAPI.actions.createSiteAddition;
    return this.$$call(api, {}, addition, {});
  }


  updateSiteAddition(additionId, addition) {
    const api = this.PricePlanBundleAPI.actions.updateSiteAddition;
    return this.$$call(api, {}, addition, {id: additionId});
  }


  deleteSiteAddition(additionId) {
    const api = this.PricePlanBundleAPI.actions.deleteSiteAddition;
    return this.$$call(api, {}, {}, {id: additionId});
  }


  setSiteServiceProgramType(serviceType, programId) {
    const api = this.PricePlanBundleAPI.actions.setSiteServiceProgramType;
    return this.$$call(api, {}, {value: programId}, {serviceType: serviceType});
  }


  getBundleById(bundleId?, accountId?) {
    const api = this.PricePlanBundleAPI.actions.getBundleById;
    return this.$$call(api, {accountId: accountId}, {}, {bundleId: bundleId});
  }


  getAllBundles() {
    const api = this.PricePlanBundleAPI.actions.getAllBundles;
    return this.$$call(api, {}, {}, {});
  }


  getAllChilds(bundleId) {
    const api = this.PricePlanBundleAPI.actions.getAllChilds;
    return this.$$call(api, {}, {}, {bundleId: bundleId});
  }


  editBundle(bundleId?, bundle?, accountId?) {
    if (accountId) {
      const api = this.PricePlanBundleAPI.actions.updateAccountBundle;
      return this.$$call(api, {}, bundle, {accountId: accountId});
    } else {
      return this.$pricePlanBundle(bundleId).$update(bundle, {}, {});
    }
  }


  updateAccountProgram(accountId) {
    const api = this.PricePlanBundleAPI.actions.updateAccountBundle;
    return this.$$call(api, {}, {}, {accountId: accountId});
  }


  setAccountPricePlanBundle(accountId, bundleId) {
    const api = this.PricePlanBundleAPI.actions.setAccountPricePlanBundle;
    return this.$$call(api, {accountId: accountId}, {}, {bundleId: bundleId});
  }


  createBundle(payload) {
    const api = this.PricePlanBundleAPI.actions.createBundle;
    return this.$$call(api, {}, payload, {});
  }


  duplicateBundle(bundleId, duplicateBundle) {
    const api = this.PricePlanBundleAPI.actions.duplicateBundle;
    return this.$$call(api, {}, duplicateBundle, {bundleId: bundleId});
  }


  setAsDefault(bundleId) {
    const api = this.PricePlanBundleAPI.actions.setAsDefault;
    return this.$$call(api, {}, {}, {bundleId: bundleId});
  }

  createProgram(program, enabled) {
    const api = this.PricePlanBundleAPI.actions.createProgram;
    return this.$$call(api, {enabled: enabled}, program, {});
  }

  updateProgram(id, program) {
    const api = this.PricePlanBundleAPI.actions.updateProgram;
    return this.$$call(api, {}, program, {id: id});
  }

  getPackageItems() {
    const api = this.PricePlanBundleAPI.actions.getPackageItems;
    return this.$$call(api, {}, {}, {});
  }

  createPackageItem(packageItem: ItemSetting) {
    const api = this.PricePlanBundleAPI.actions.createPackageItem;
    return this.$$call(api, {}, packageItem, {});
  }

  updatePackageItem(itemId, packageItem: ItemSetting) {
    const api = this.PricePlanBundleAPI.actions.updatePackageItem;
    return this.$$call(api, {}, packageItem, {itemId: itemId});
  }

  setDefaultPackageItem(itemId) {
    const api = this.PricePlanBundleAPI.actions.setDefaultPackageItem;
    return this.$$call(api, {}, {}, {itemId: itemId});
  }

  getHierarchy() {
    const api = this.PricePlanBundleAPI.actions.getHierarchy;
    return this.$$call(api, {}, {}, {});
  }

  updatePricePlanBundleAccounts(pricePlanBundleId: string, accountIds: string[]) {
    const api = this.PricePlanBundleAPI.actions.updateAccounts;
    return this.$$call(api, {}, accountIds, {pricePlanBundleId: pricePlanBundleId});
  }

  exportPrograms(pricePlanBundleId: string, payload: ExportPricePlanPayloadModel) {
    const api = this.PricePlanBundleAPI.actions.exportPrograms;
    return this.$$call(api, {}, payload, {id: pricePlanBundleId});
  }

  getLineSplitConfiguration() {
    const api = this.PricePlanBundleAPI.actions.getLineSplitConfiguration;
    return this.$$call(api, {}, {}, {});
  }

  updateLineSplitConfiguration(lineSplitConfiguration) {
    const api = this.PricePlanBundleAPI.actions.updateLineSplitConfiguration;
    return this.$$call(api, {}, lineSplitConfiguration, {});
  }

  getServiceValidations() {
    const api = this.PricePlanBundleAPI.actions.getServiceValidations;
    return this.$$call(api, {}, {}, {});
  }

  createServiceValidations(serviceValidation: ServiceValidationTemplateModel) {
    const api = this.PricePlanBundleAPI.actions.createServiceValidations;
    return this.$$call(api, {}, serviceValidation, {});
  }

  updateServiceValidations(serviceValidation: ServiceValidationTemplateModel) {
    const api = this.PricePlanBundleAPI.actions.updateServiceValidations;
    return this.$$call(api, {}, serviceValidation, {id: serviceValidation.id});
  }

  // ******************************
  // Internal methods
  // ******************************


  $$call(_apiCall, _params, _data, _options) {
    return this.$pricePlanBundle().$call(_apiCall, _params, _data, _options, true);
  }
}

angular
  .module('bringoz.admin.pricePlan')
  .service('pricePlanBundleRequestsService', PricePlanBundleRequestsService);
